
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pam/vendor-access",
      function () {
        return require("private-next-pages/pam/vendor-access.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pam/vendor-access"])
      });
    }
  